import { render, staticRenderFns } from "./GestionDeProveedores.vue?vue&type=template&id=41f49efa&scoped=true"
import script from "./GestionDeProveedores.vue?vue&type=script&lang=js"
export * from "./GestionDeProveedores.vue?vue&type=script&lang=js"
import style0 from "./GestionDeProveedores.vue?vue&type=style&index=0&id=41f49efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f49efa",
  null
  
)

export default component.exports